package org.hs_soft.runmynesto.pages.login.component

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.silk.components.text.SpanText
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.FontFamily
import org.hs_soft.runmynesto.domain.config.FontSizes
import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.util.Res
import org.hs_soft.runmynesto.pages.components.VectorIcon
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Composable
fun PasswordRequirementItem(
    modifier: Modifier = Modifier,
    text: String,
    isMet: Boolean,
) {
    Row(
        modifier = modifier.margin(bottom = Dimen.normalPadding),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Box(
            modifier = Modifier
                .borderRadius(50.percent)
                .backgroundColor(
                    if (isMet) Theme.SuccessMain.rgb
                    else Theme.Transparent.rgb
                )
                .border(
                    width = if (isMet) 0.px else Dimen.smallThickness,
                    color = Theme.TextDisabled.rgb,
                    style = LineStyle.Solid,
                )
                .size(Dimen.smallIconSize.px),
            contentAlignment = Alignment.Center
        ) {

            if (isMet) {
                VectorIcon(
                    width = Dimen.smallIconSize,
                    height = Dimen.smallIconSize,
                    color = Theme.White.hex,
                    pathData = Res.PathIcon.approve
                )

            }
        }

        SpanText(
            text = text,
            modifier = Modifier
                .margin(left = Dimen.normalPadding)
                .fontSize(FontSizes.semiMediumFontSize)
                .fontWeight(FontWeight.Normal)
                .fontFamily(FontFamily.Jakarta)
                .color(if (isMet) Theme.SuccessMain.rgb else Theme.TextSecondary.rgb)
        )
    }
} 